module.exports = __webpack_public_path__ + "static/assets/b2838fd316505dfed435317ef645bc96.png";